/*
Author: Vaishnavi
Date: 21/11/2019
Issue Description: Padding for the Organisation Summary heading given (line no. 97)
*/
<template>
<v-navigation-drawer permanent class="onboarding navDrawer" width="250" >
  <div class="navContainer">
    <div class="logo-box">
      <div class="backUrl" v-if="backLinkText && backLinkUrl" @click="$router.push(backLinkUrl)">
        <img class="icon" src="@/assets/path-2-copy.png" />
        <span class="text-purple">{{ backLinkText }}</span>
      </div>
      <div class="nav-title" v-if="title">
        <span><img :src="logoUrl" alt=""></span>
      </div>
      <div><span v-if="title" class="logo-title">{{ title }}</span></div>
    </div>
    <section v-for="(s,i) of items" :key="i">
      <header>{{s.header}}</header>
      <div v-for="(ni,i) of s.items" :key="i">
        <div class="navItem" v-bind:class="[ni.status]">
          <div class="statusIcon" :class="{ 'animated pulse': ni.status == 'error' }"></div>
          <router-link class="label" :to="ni.path" @click.native="updateNavBar(ni)">
            <label class="stepper-label">{{ni.label}}</label>
          </router-link>
        </div>
        <div v-if="i < (s.items.length-1)" class="dashed-line" :class="[ni.status]"></div>
      </div>
    </section>
  </div>
</v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "onboardingNavDrawer",
  props: ['items', 'title', 'backLinkText', 'backIcon', 'backLinkUrl','logoUrl'],
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      act_changeNavBar: "onboard/legal_entities/updateNavBarState"
    }),

    updateView(view) {
      this.$emit("updateView", view);
    },

    updateNavBar(navItem) {
      this.act_changeNavBar({
        le_index: this.$route.params.entity_index,
        code: navItem.code,
        prev_state: navItem.prev_status,
        state: 'active',
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.router-link-exact-active,.router-link-active {
    &.label {
        // color: #000000;
        // font-weight: bold;
    }
}
// %circle {
//     background-color: white !important;
//     border: 1px solid #303030;
//     height: 12px;
//     width: 12px;
//     min-width: 0;
//     border-radius: 50%;
// }
%circle {
    // background-color: white !important;
    border: 2px solid #dadada;
    height: 16px;
    width: 16px;
    min-width: 0;
    border-radius: 50%;
}

// %circle-filled {
//     background-color: #5d409f !important;
//     border: 1px solid #303030;
//     height: 12px;
//     width: 12px;
//     min-width: 0;
//     border-radius: 50%;
// }

%circle-filled {
    background-color: #dadada;
    // border: 1px solid #303030;
    height: 18px;
    width: 18px;
    min-width: 0;
    border-radius: 50%;
}

.dashed-line {
    height: 25px;
    border-left: 1px dashed #b0b0b0;
    margin-left: 5px;
    margin-top: 4px;
    margin-bottom: 4px;
}

.nav-title {
    margin-bottom: 32px;
    font-size: 16px;
    color: #9c9c9c;
    overflow-wrap: break-word;
    img{
        width: 70px;
        height: 70px;
        object-fit: contain;
        border-radius: 50%;
    }
}

.onboarding {
    font-family: Montserrat;
    position: relative;

    .navContainer {
        width: 242px;
        position: relative;
        display: block;
        padding-left: 32px;
        padding-top: 32px;
        padding-right: 16px;
        font-size: 14px;

        .backUrl {
            display: flex;
            cursor: pointer;
            user-select: none;

            .icon {
                height: 12px;
                padding-right: 12px;
                margin-top: 3px;
            }

            .text-purple {
                color: $color-primary;
                font-weight: bold;
            }
        }

        section {
            padding-bottom: 16px;
            margin-bottom: 26px;

            header {
                font-size: 12px;
                padding-bottom: 10px;
            }

            .dashed-line {
                height: 25px;
                border-left: 2px solid #dadada;
                border-radius: 2px;
                margin-left: 9px;
                &.complete {
                    border-color: $color-secondary;
                }
                &.error {
                  border-color: #ffa000;
                }
            }

            .navItem {
                display: flex;
                align-items: center;

                .statusIcon {
                    margin-right: 10px;
                }

                .label {
                    text-decoration: none;
                    color: #6e6e6e;
                    cursor: pointer;
                    font-size: 14px !important;
                }

                &.pending {
                    // pointer-events: none;
                    .statusIcon {
                        @extend %circle-filled;
                        margin-left: 1px;
                        cursor: pointer;
                    }
                }

                &.error {
                    a.label {
                        color: #ffa000;
                        font-weight: 500;
                      &:hover {
                        text-decoration: underline;
                      }
                    }

                    .statusIcon {
                        background-image: url('../../../../assets/error_stepper.svg');
                        height: 20px;
                        width: 20px;
                        cursor: pointer;
                        &.animated {
                          animation-name: pulse;
                          animation-iteration-count: infinite;
                          animation-duration: 3s;
                          -webkit-animation-name: pulse;
                          -webkit-animation-iteration-count: infinite;
                          -webkit-animation-duration: 3s;
                        }
                    }
                }

                &.active {
                    a.label {
                        color: $color-secondary;
                        font-weight: bold;
                    }

                    .statusIcon {
                        background-image: url('../../../../assets/current_stepper.svg');
                        height: 20px;
                        width: 20px;
                        cursor: pointer;
                        -webkit-animation:spin 3s linear infinite;
                        -moz-animation:spin 3s linear infinite;
                        animation:spin 3s linear infinite;
                    }
                }

                &.complete {
                    a.label {
                        color: $color-secondary;
                        font-weight: 500;
                        &:hover {
                          text-decoration: underline;
                        }
                    }

                    .statusIcon {
                        background-image: url('../../../../assets/check_stepper.svg');
                        height: 20px;
                        width: 20px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    // .navItem {}
}
.stepper-label {
  cursor: pointer;
}
.navDrawer {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.1);
    background-color: #f9f9f9;
    width: 242px;
    float: left;
  //  height: stretch;
    height: calc(100vh - 66px);
    position: fixed;
    padding-bottom: 66px;
    overflow: auto;
    top: 65px;
    z-index: 0;
}

.logo-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    >:nth-child(n) {
      margin-bottom: 16px;
    }
    >:last-child {
      margin-bottom: 32px;
    }
    .logo-title {
       font-weight: 600;
       font-size: 14px;
       color: #444444;
       font-family: Montserrat;
       margin-right: 22px;
    }
    .nav-title {
      margin-right: 22px;
    }
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform:rotate(360deg);
  }
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
</style>
